import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon72: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 20" width={width} height={height} {...props}>
      <Path
        d="M11.1756 5.42326L3.79364 12.9722C2.94764 13.8372 2.94462 15.2343 3.78762 16.0963C4.63762 16.9643 6.02262 16.9612 6.87362 16.0902L17.0046 5.72926C18.3046 4.40126 18.3406 2.30726 17.0566 0.992256C15.7586 -0.334744 13.6476 -0.329742 12.3466 1.00126L1.40362 12.1932C-0.150379 13.7842 -0.472376 16.2672 0.731624 18.0422C2.32262 20.3892 5.55563 20.6623 7.49963 18.6733L15.8316 10.1533C16.0246 9.95627 16.0206 9.63927 15.8236 9.44627C15.6256 9.25327 15.3096 9.25726 15.1166 9.45426L6.78564 17.9743C5.28064 19.5123 2.79363 19.3023 1.55963 17.4803C0.632627 16.1143 0.885618 14.1542 2.11862 12.8922L13.0616 1.70025C13.9716 0.770248 15.4366 0.766245 16.3416 1.69125C17.2396 2.61125 17.2146 4.08525 16.2896 5.03025L6.15863 15.3912C5.69863 15.8612 4.95962 15.8633 4.50262 15.3973C4.04062 14.9243 4.04163 14.1482 4.50863 13.6712L11.8896 6.12225C12.0836 5.92525 12.0796 5.60824 11.8826 5.41524C11.6846 5.22224 11.3686 5.22626 11.1756 5.42326Z"
        fill="#404040"
      />
    </Icon>
  )
}
